<template>
	<div class="chat-box" @click="closeRefBox()" @mousemove="readedMessage()">
		<el-container>
			<!-- 头部区域 -->
			<el-header height="50px">
				<div class="header-left">
					<span>{{ title }}</span>
					<el-tag v-if="chatTypeTag" :type="chatTypeTag.type" size="small" effect="dark" class="header-type-tag">{{ chatTypeTag.label }}</el-tag>
				</div>
				<div class="header-right">
					<el-button
						v-if="showReAddBtn"
						type="warning"
						size="small"
						plain
						:loading="reAddLoading"
						@click="onReAddFriend"
					>重新添加</el-button>
					<AccountBadge :accountInfo="accountInfo" :loading="accountLoading" />
					<!-- 群聊信息入口：打开右侧群信息侧栏（群成员/群设置），仅群聊会话显示 -->
					<span title="群聊信息" v-show="isGroup" class="btn-side el-icon-more" @click.stop="showSide = !showSide"></span>
				</div>
			</el-header>
			<!-- 消息内容 和 输入框内容 -->
			<el-main style="padding: 0; overflow: hidden; display: flex; flex-direction: column;">
				<el-container>
					<el-container class="content-box is-vertical">
						<el-main class="im-chat-main" id="chatScrollBox" @scroll.native="onScroll" v-loading="chat._hotLoading" element-loading-text="加载消息中...">
							<div class="im-chat-box" ref="chatMessages">
								<!-- 顶部占位：未渲染的旧消息高度 -->
								<div v-if="topSpacerHeight > 0" :style="{ height: topSpacerHeight + 'px' }"></div>
								<div v-if="loadingColdPage" style="text-align:center;padding:8px;color:#999;font-size:12px">加载历史消息...</div>
								<div v-for="(msgInfo, idx) in showMessages" :key="msgInfo.id || msgInfo.tmpID || msgInfo.tmpId || msgInfo._key || idx">
									<!-- 显示时间间隔提示（消息间隔大于10分钟） -->
									<div v-if="showTimeTip(msgInfo, idx)" class="message-time-tip">
										{{ formatTimeTip(msgInfo.sendTime) }}
									</div>
									<chat-message-item @call="onCall(msgInfo.msgType)" :mine="msgInfo.isWX"
										:headImage="headImage(msgInfo)" :showName="showName(msgInfo)" :msgInfo="msgInfo"
										@resend="onResendMessage" @delete="deleteMessage"
										@recall="recallMessage" @forward="openForwardDialog" @collect="openCollectQuickReply">
									</chat-message-item>
								</div>
								<!-- 底部占位：未渲染的新消息高度 -->
								<div v-if="bottomSpacerHeight > 0" :style="{ height: bottomSpacerHeight + 'px' }"></div>
							</div>
						</el-main>
						<div v-if="!isInBottom" class="scroll-to-bottom" @click="scrollToBottom">
							{{ newMessageSize > 0 ? newMessageSize + '条新消息' : '回到底部' }}
						</div>
						<el-footer height="220px" class="im-chat-footer">
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div title="发送图片">
									<file-upload :action="IMAGE_UPLOAD_URL" :maxSize="2 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送文件">
									<file-upload ref="fileUpload" :action="FILE_UPLOAD_URL" :maxSize="10 * 1024 * 1024"
										@before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<!-- 视频消息专用入口：manual 仅选择文件，截帧/封面/上传/发送由 sendVideoMessage 链路完成 -->
								<div title="发送视频">
									<file-upload ref="videoUpload" manual accept="video/*" :maxSize="25 * 1024 * 1024"
										@before="onVideoBefore">
										<i class="el-icon-video-camera"></i>
									</file-upload>
								</div>
								<div title="发送位置" @click="showLocationPicker">
									<i class="el-icon-location-outline"></i>
								</div>
								<!-- 发送名片：选择好友后像发消息一样发送（微信式） -->
								<div title="发送名片" class="el-icon-postcard" @click="openCardPicker">
								</div>
								<div title="回执消息" v-show="isGroup && memberSize <= 500"
									class="icon iconfont icon-receipt" :class="isReceipt ? 'chat-tool-active' : ''"
									@click="onSwitchReceipt">
								</div>
								<div title="发送语音" class="el-icon-microphone" @click="showRecordBox()">
								</div>
								<!-- 内容脱敏入口：打开企盾脱敏工具页，原文复制到工具生成后，再把结果复制回输入框发送 -->
								<div title="内容脱敏" class="el-icon-magic-stick" @click="openDesensitizeTool()">
								</div>
								<!-- <div title="聊天记录" class="el-icon-chat-dot-round" @click="showHistoryBox()">
								</div> -->
							</div>
							<div class="send-content-area">
								<!-- 注意：必须用 camelCase conversationID 绑定——Vue 2.7 hyphenate 对
								     连续大写 ID 生成 conversation-i-d，kebab 写法 conversation-id 提取不到
								     prop 恒为空导致选择器永不加载（线上实测） -->
								<group-account-selector v-if="isGroup" :conversationID="chat.conversationID"
									ref="groupAccountSelector" @change="onSendAccountChange" />
								<ChatInput :ownerId="group.ownerId" ref="chatInputEditor" :group-members="groupMembers"
									@submit="sendMessage" />
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion"
										@click="notifySend()">发送</el-button>
								</div>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="side-box" width="320px" v-if="showSide">
						<chat-group-side :group="group" :groupMembers="groupMembers"
							:conversationID="chat.conversationID" :isDnd="!!chat.isDnd"
							@reload="loadGroup(group.id)" @close="onCloseSide"></chat-group-side>
					</el-aside>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<location-picker ref="locationPicker" @confirm="onLocationConfirm"></location-picker>
			<!-- 发送视频确认：按钮选文件后先预览确认再发送，避免选择即误发 -->
			<el-dialog title="发送视频" :visible.sync="videoConfirmVisible" width="420px"
				:close-on-click-modal="false" @close="cleanVideoConfirm">
				<video v-if="videoUrl" ref="videoConfirmPlayer" :src="videoUrl" controls preload="metadata"
					@loadedmetadata="onVideoMetaLoaded" class="video-confirm-player"></video>
				<div class="video-confirm-info">
					<div class="video-confirm-name" :title="videoNameText">{{ videoNameText }}</div>
					<div class="video-confirm-meta">
						<span>大小：{{ videoSizeText }}</span>
						<span v-if="videoDuration > 0">时长：{{ videoDuration }}秒</span>
					</div>
					<div v-if="videoFile && videoFile.size >= 25 * 1024 * 1024" class="video-confirm-hint">
						超过25MB将按文件发送
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="cancelVideoConfirm">取消</el-button>
					<el-button size="small" type="primary" @click="confirmSendVideo">发送</el-button>
				</div>
			</el-dialog>
			<!-- 转发小程序到其他客户/群：单选目标会话，素材原样透传 send_message4 发送 -->
			<el-dialog class="chat-forward-dialog" title="转发到" :visible.sync="forwardVisible" width="480px" :close-on-click-modal="false"
				append-to-body @open="onForwardDialogOpen" @closed="onForwardDialogClosed">
				<div class="forward-preview" v-if="forwardMsg">
					<span class="forward-preview-label">转发内容：</span>
					<span class="forward-preview-title">{{ forwardTitle }}</span>
				</div>
				<el-input v-model="forwardKeyword" placeholder="搜索客户/群名称" clearable size="small" class="forward-search">
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
				<div class="forward-target-list">
					<div v-if="forwardCandidates.length === 0" class="forward-empty">没有可转发会话（搜索不到或已无可发送会话）</div>
					<div v-for="target in forwardCandidates" :key="target.conversationID"
						class="forward-target-item" :class="{ 'is-active': forwardTarget && forwardTarget.conversationID === target.conversationID }"
						@click="forwardTarget = target">
						<el-avatar :size="32" :src="target.faceURL">{{ (target.showName || '?').substring(0, 1) }}</el-avatar>
						<div class="forward-target-info">
							<div class="forward-target-name">{{ target.showName || target.conversationID }}</div>
							<div class="forward-target-meta">{{ target.convType === 'group' ? '群聊' : '单聊' }}</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="forwardVisible = false">取消</el-button>
					<el-button size="small" type="primary" :disabled="!forwardTarget" :loading="forwardSending"
						@click="confirmForward">发送</el-button>
				</div>
			</el-dialog>
			<!-- 收藏小程序为快捷回复：命名后素材（MicroProgramElem JSON）存入快捷回复，
				也是自动回复"小程序消息"的素材来源；发送时同素材复用 -->
			<el-dialog class="chat-collect-dialog" title="设为快捷回复" :visible.sync="collectVisible" width="420px"
				:close-on-click-modal="false" append-to-body @open="onCollectDialogOpen" @closed="onCollectDialogClosed">
				<div class="collect-preview" v-if="collectMsg">
					<span class="collect-preview-label">小程序：</span>
					<span class="collect-preview-title">{{ collectTitle }}</span>
				</div>
				<el-input v-model="collectName" placeholder="请输入快捷回复名称" maxlength="32" show-word-limit
					size="small" class="collect-name-input" @keyup.enter.native="confirmCollectQuickReply">
				</el-input>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="collectVisible = false">取消</el-button>
					<el-button size="small" type="primary" :loading="collectSaving" @click="confirmCollectQuickReply">保存</el-button>
				</div>
			</el-dialog>
			<!-- 发送名片：选择好友（微信式"选择朋友"面板）后像发消息一样发送到当前会话 -->
			<card-picker-dialog :visible.sync="cardPickerVisible" @select="onCardPicked" />
			<!-- <chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group"
				:groupMembers="groupMembers" @close="closeHistoryBox"></chat-history> -->
		</el-container>
	</div>
</template>

<script>
import axios from 'axios'
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import ChatInput from "./ChatInput";
import GroupAccountSelector from "./GroupAccountSelector.vue";
import AccountBadge from "./AccountBadge.vue";
import LocationPicker from "./LocationPicker.vue";
import CardPickerDialog from "./CardPickerDialog.vue";
import { updateMessageStatus, sendMessage, deleteFailedMessage } from "../../api/message.js";
import { uploadImage, uploadFile, IMAGE_UPLOAD_URL, FILE_UPLOAD_URL } from "../../api/upload.js";
import { recallMessage as recallMessageApi } from "../../api/conversation.js";
import { findUserById } from "../../api/legacy.js";
import { addQuickReply } from "../../api/quickReply.js";
import { getAccountInfo, getGroupDetail } from "../../api/user.js";
import { extractParticipants, parseConversationID } from "@/utils/conversation";
import { readVideoMeta, isVideoFile } from "@/utils/video";


export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		GroupAccountSelector,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		Emotion,
		ChatRecord,
			ChatHistory,
		ChatAtBox,
		AccountBadge,
		LocationPicker,
		CardPickerDialog
		},
		props: {
		chat: {
			type: Object
		}
	},
	data() {
		return {
			IMAGE_UPLOAD_URL,
			FILE_UPLOAD_URL,
			userInfo: {},
			group: {},
			groupMembers: [],
			groupLoadSeq: 0, // 群详情请求序列号：仅接受最新一次请求的响应（防快速切换群时旧响应覆盖）
			sendImageUrl: "",
			sendImageFile: "",
			placeholder: "",
			isReceipt: true,
			sendAccountVID: "", // 群聊当前发送账号（空=后端自动选号）
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			videoConfirmVisible: false, // 发送视频确认弹窗是否显示
			videoFile: null, // 待确认发送的视频文件
			videoUrl: "", // 视频本地预览 objectURL
			videoNameText: "", // 预览文件名
			videoSizeText: "", // 预览文件大小文本
			videoDuration: 0, // 预览视频时长(秒)
			forwardVisible: false, // 转发弹窗是否显示
			collectVisible: false, // 收藏小程序为快捷回复弹窗
			collectMsg: null, // 待收藏的小程序消息
			collectName: '', // 收藏命名
			collectSaving: false, // 收藏保存中
			forwardMsg: null, // 待转发的小程序消息对象
			forwardTarget: null, // 选中的目标会话
			forwardKeyword: '', // 转发目标搜索关键字
			forwardSending: false, // 转发发送中
			forwardTmpID: '', // 本次转发复用 tmpID（超时重试命中服务端防重，避免重复投递）
				showHistory: false, // 是否显示历史聊天记录
			lockMessage: false, // 是否锁定发送，
			cardPickerVisible: false, // 发送名片-选择好友弹窗
			visStart: 0,           // 虚拟滚动：当前渲染窗口起始下标
			visEnd: 0,             // 虚拟滚动：当前渲染窗口结束下标（不含）
			windowSize: 50,        // 虚拟滚动：窗口中最多渲染的消息数
			avgMsgHeight: 62,      // 虚拟滚动：未渲染消息的单条估算高度(px)
			msgHeights: {},       // 虚拟滚动：已渲染消息的实际高度缓存 { msgId: height }
			heightPrefixSum: [],  // 性能优化：prefixSum[i] = 前i条消息累计高度, spacer O(1)查询
			scrollStabilizing: false, // 虚拟滚动：窗口平移中，防止重复触发
			scrollTicking: false,    // rAF 节流标记
			loadingColdPage: false, // 冷页加载中，防止并发
			reqQueue: [], // 等待发送的请求队列
			isSending: false, // 是否正在发消息
			isInBottom: false, // 滚动条是否在底部
			newMessageSize: 0, // 滚动条不在底部时新的消息数量
			maxTmpId: 0, // 最后生成的临时ID
			accountInfo: null, // 当前会话关联的企微账号信息
			accountLoading: false, // 账号信息加载中
			cancelTokenSource: null, // 账号信息请求取消令牌
			reAddLoading: false, // 重新添加好友按钮 loading
		}
	},
	methods: {
		// 置顶
		moveChatToTop() {
			let chatIdx = this.chatStore.findChatIdx(this.chat);
			this.chatStore.moveTop(chatIdx);
		},
		// 关闭引用的box
		closeRefBox() {
			this.$refs.emoBox.close();
			// this.$refs.atBox.close();
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
			this.refreshPlaceHolder();
		},
		// 图片上传成功
		onImageSuccess(data, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify({sourcePath: data.path});
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				msgInfo.sendTime = m.sendTime
				msgInfo.senderName = m.senderName;
				msgInfo.senderFaceURL = m.senderFaceURL
				msgInfo.status = m.status;
				this.isReceipt = false;
				this.chatStore.updateMessage(msgInfo, file.chat);
			}).catch(() => {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, file.chat);
			})
		},
		// 图片上传错误
		onImageFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
			this.chatStore.updateMessage(msgInfo, file.chat);
		},
		// 选中图片之后的检查
		onImageBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			// 图片参数（符合后端 PictureElem 结构）
			let data = {
				sourcePath: url,
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				tmpID: this.generateId(), // 临时消息id
				conversationID : this.chat.conversationID, // 会话ID
				syncKey: '',
				isWX: true,
				isRoom: 0,
				roomID: '',
				sender: this.getWXID(this.chat.conversationID),
				senderName: '',
				sendTime: parseInt(new Date().getTime() / 1000),
				senderFaceURL: '',
				receiver: this.getWechatID(this.chat.conversationID),
				receiverName: '',
				receiverFaceURL: '',
				rawMsgID: 0,
				rawMsgType: 0,			
				msgType: this.$enums.MESSAGE_TYPE.IMAGE, // 图片（值为2）
				content: JSON.stringify(data),
				isRead: true,
				status: this.$enums.MESSAGE_STATUS.PENDING, // 未送达（值为0）
				serverID: 0,
				// 捕获当前发送账号：上传完成发送时可能已切换会话（sendAccountVID 被清空），
				// 用实时值会把消息发进旧会话却用新会话的账号，造成账号串号
				accountVID: this.sendAccountVID || "",
			}
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 借助file对象保存
			file.msgInfo = msgInfo;
			file.chat = this.chat;
		},
		// 文件上传成功
		onFileSuccess(data, file) {
			let fileElem = {
				name: file.name,
				size: file.size,
				url: data.path,
				path: data.path,
				ext: data.ext
			}
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(fileElem);
			msgInfo.receipt = this.isReceipt
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				msgInfo.sendTime = m.sendTime;
				msgInfo.senderName = m.senderName;
				msgInfo.senderFaceURL = m.senderFaceURL				
				msgInfo.status = m.status;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.chatStore.updateMessage(msgInfo, file.chat);
			}).catch(() => {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, file.chat);
			})
		},
		// 文件上传失败
		onFileFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
			this.chatStore.updateMessage(msgInfo, file.chat);
		},
		// 视频按钮选中：先弹确认弹窗（预览确认后再发送，避免选择即误发）
		onVideoBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			// 兜底校验（accept 仅过滤选择框 UI，文件类型判定仍需扩展名，与视频快捷回复共用 utils/video.js）
			if (!isVideoFile(file)) {
				this.$message.warning('仅支持发送视频文件（mp4/mov/avi/mkv/webm/flv/rmvb）');
				return;
			}
			// 确认弹窗单例守卫：选择器支持多选，若已有文件待确认则忽略新选择，
			// 避免后选文件静默覆盖前一个待确认视频
			if (this.videoConfirmVisible || this.videoFile) {
				this.$message.warning('已有视频待确认发送，请先确认或取消后再选择');
				return;
			}
			this.videoFile = file;
			this.videoNameText = file.name;
			this.videoSizeText = (file.size / 1024 / 1024).toFixed(2) + ' MB';
			this.videoDuration = 0;
			this.videoUrl = URL.createObjectURL(file);
			this.videoConfirmVisible = true;
		},
		// 确认发送：关闭弹窗进入视频消息发送链路（截帧封面+上传+发送）
		confirmSendVideo() {
			let file = this.videoFile;
			this.videoConfirmVisible = false;
			this.cleanVideoConfirm();
			if (!file) {
				return;
			}
			this.sendVideoMessage(file);
			this.$nextTick(() => this.$refs.chatInputEditor && this.$refs.chatInputEditor.focus());
			this.scrollToBottom();
		},
		// 取消发送
		cancelVideoConfirm() {
			this.videoConfirmVisible = false;
			this.cleanVideoConfirm();
		},
		// 清理确认弹窗预览资源（objectURL 必须 revoke，防内存泄漏）
		cleanVideoConfirm() {
			if (this.videoUrl) {
				URL.revokeObjectURL(this.videoUrl);
			}
			this.videoUrl = "";
			this.videoFile = null;
			this.videoNameText = "";
			this.videoSizeText = "";
			this.videoDuration = 0;
		},
		// 预览元数据就绪：回填时长
		onVideoMetaLoaded(e) {
			let d = e.target && e.target.duration;
			if (isFinite(d) && d > 0) {
				this.videoDuration = Math.round(d);
			}
		},
		// 选中文件
		onFileBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			// 文件参数（符合后端 FileElem 结构）
			let data = {
				name: file.name,
				size: file.size,
				url: url,
				path: url
			}
			let msgInfo = {
				tmpID: this.generateId(), // 临时消息id
				conversationID : this.chat.conversationID, // 会话ID
				syncKey: '',
				isWX: true,
				isRoom: 0,
				roomID: '',
				sender: this.getWXID(this.chat.conversationID),
				senderName: '',
				sendTime: parseInt(new Date().getTime() / 1000),
				senderFaceURL: '',
				receiver: this.getWechatID(this.chat.conversationID),
				receiverName: '',
				receiverFaceURL: '',
				rawMsgID: 0,
				rawMsgType: 0,			
				msgType: this.$enums.MESSAGE_TYPE.FILE, // 文件（值为4）
				content: JSON.stringify(data),
				isRead: true,
				status: this.$enums.MESSAGE_STATUS.PENDING, // 未送达（值为0）
				serverID: 0,
				// 捕获当前发送账号：上传完成发送时可能已切换会话（sendAccountVID 被清空），
				// 用实时值会把消息发进旧会话却用新会话的账号，造成账号串号
				accountVID: this.sendAccountVID || "",
			}
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
		},
		onCloseSide() {
			this.showSide = false;
		},
		onScrollToTop() {
			// 窗口向上平移 20 条
			if (this.visStart > 0 && !this.scrollStabilizing) {
				this.shiftWindow(-20);
			}
		},
		onScroll(e) {
			// rAF 节流：同一帧内多次触发只执行一次
			if (this.scrollTicking) return;
			this.scrollTicking = true;
			requestAnimationFrame(() => {
				this.scrollTicking = false;
				const el = e.target;
				const st = el.scrollTop;
				const sh = el.scrollHeight;
				const ch = el.clientHeight;
				const len = this.chat?.messages?.length || 0;

				if (this.scrollStabilizing) return;

					// 滚动到绝对顶部 → 加载更早的冷消息页
					if (st < 100 && this.visStart === 0 && this.chat && !this.chat._allColdLoaded && !this.loadingColdPage) {
						console.warn('[ChatBox] scroll trigger loadOlderMessages', { st, convID: this.chat.conversationID, _allColdLoaded: this.chat._allColdLoaded, msgCount: this.chat.messages?.length });
						this.loadOlderMessages(el);
					} else if (st < 100 && this.chat) {
						console.warn('[ChatBox] scroll skip loadOlderMessages', { st, visStart: this.visStart, convID: this.chat.conversationID, _allColdLoaded: this.chat._allColdLoaded, loadingColdPage: this.loadingColdPage, msgCount: this.chat.messages?.length });
					}
					
					// 滚到顶部附近 → 窗口上移（展示更早的消息）
				if (st < this.topSpacerHeight + 200 && this.visStart > 0) {
					this.shiftWindow(-20, el);
				}

				if (st + ch >= sh - this.bottomSpacerHeight - 200 && this.visEnd < len) {
					this.shiftWindow(20, el);
				}

				if (st + ch >= sh - 30 && this.visEnd >= len) {
					this.isInBottom = true;
					this.newMessageSize = 0;
				} else if (st + ch < sh - 50) {
					this.isInBottom = false;
				}
			});
		},
		onReAddFriend() {
			const { reAddFriend } = require('../../api/user.js');
			this.reAddLoading = true;
			const capturedConvID = this.chat.conversationID;
			const userID = this.chat.personalUserID;
			const identity = this.chat.identity;
			this.$confirm('确定要重新添加该好友吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'info'
			}).then(() => {
				if (this.chat?.conversationID !== capturedConvID) return;
				return reAddFriend({ identity, userID }).then(() => {
					this.$message.success('好友请求已发送');
					this.friendStore.updateFriend({
						userID: userID,
						status: 9
					});
				}).catch(err => {
					// 错误已由全局拦截器提示
				});
			}).catch(() => {}).finally(() => {
				this.reAddLoading = false;
			});
		},
		// 加载更早的历史消息（冷页），与虚拟滚动联动
		async loadOlderMessages(scrollEl) {
			this.loadingColdPage = true;
			const el = scrollEl || document.getElementById('chatScrollBox');
			const oldSh = el ? el.scrollHeight : 0;
			const oldSt = el ? el.scrollTop : 0;

			try {
				const targetConvID = this.chat.conversationID;
				const result = await this.chatStore.loadColdPage(targetConvID);
				if (this.chat?.conversationID !== targetConvID) return; // 会话已切换，丢弃
				if (result && result.coldMsgs && result.coldMsgs.length > 0) {
					// 原子更新：messages、pageIdx、visStart、visEnd 在同一同步块，Vue 只触发一次渲染
					this.chat.messages = result.merged;
					this.chat._coldPageLoaded = result.pageIdx;
					const added = result.coldMsgs.length;
					this.visStart += added;
					this.visEnd = Math.min(this.visStart + this.windowSize, result.merged.length);
					if (el) {
						// 重建 heightPrefixSum，确保 218 条而非 200 条的 scrollHeight
						this._updateHeightPrefixSum();
						this.$nextTick(() => {
							el.scrollTop = el.scrollHeight;            // force layout
							el.scrollTop = el.scrollHeight - oldSh + oldSt;
							// 滚动恢复完成后才释放锁，防止 messageSize watcher 因 lastMessage.isWX 误触发 scrollToBottom
							this.loadingColdPage = false;
						});
					} else {
						this.loadingColdPage = false;
					}
				}
			} catch (e) {
				console.error('loadOlderMessages failed:', e);
			} finally {
				// fallback: 如果 $nextTick 未执行（如异常），100ms 后强制释放锁
				setTimeout(() => { this.loadingColdPage = false; }, 100);
			}
		},
		// 兜底补齐调度：等首屏渲染与高度测量稳定后，检测聊天区是否可滚动；
		// hot 缓存仅有增量残留（WS/批量同步写入的少量消息）时聊天区不可滚动、无法产生
		// 滚动事件，导致「滚动到顶加载更早历史」的既有链路永不触发，需主动向前补齐
		_scheduleAutoFill(targetConvID) {
			setTimeout(() => {
				if (this.chat?.conversationID !== targetConvID) return;
				this._autoFillOlder(targetConvID);
			}, 300);
		},
		// 主动向前补齐更早历史：仅在聊天区不可滚动（内容撑不满容器）时执行，
		// 每轮拉取一页冷消息，直到可滚动或服务端确认无更多历史（_allColdLoaded）；
		// 轮次上限防御异常数据（如 hasMore 恒 true）下的请求风暴
		async _autoFillOlder(targetConvID) {
			for (let round = 0; round < 10; round++) {
				if (this.chat?.conversationID !== targetConvID) return; // 会话已切换
				const chat = this.chat;
				if (!chat || chat._allColdLoaded || this.loadingColdPage) return;
				const el = document.getElementById('chatScrollBox');
				// clientHeight === 0：容器未布局（隐藏/未激活）时无法判定可滚动性，跳过本轮（重新进入会话会再调度）
				if (!el || el.clientHeight === 0 || el.scrollHeight > el.clientHeight) return; // 容器缺失、未布局或已可滚动（消息充足），交由滚动链路处理
				console.warn('[ChatBox] auto fill older', { convID: targetConvID, msgCount: (chat.messages || []).length, round });
				this.loadingColdPage = true; // 复用锁：防止与滚动触发并发，并挡住 messageSize watcher 误判
				try {
					const result = await this.chatStore.loadColdPage(targetConvID);
					if (this.chat?.conversationID !== targetConvID) return;
					const loaded = !!(result && result.coldMsgs && result.coldMsgs.length > 0);
					if (!loaded) {
						// 返回 0 有多种语义（无更多历史/失败/in-flight 去重/整页重复推进页码）：
						// 仅服务端确认无更多历史（_allColdLoaded）才收敛，其余交由下一轮重试（有轮次上限）
						if (this.chat._allColdLoaded) return;
					} else {
						// 原子更新：合并更早消息，窗口保持在底部
						this.chat.messages = result.merged;
						this.chat._coldPageLoaded = result.pageIdx;
						const len = this.chat.messages.length;
						this.visStart = Math.max(0, len - this.windowSize);
						this.visEnd = len;
						this._updateHeightPrefixSum(); // 重建高度前缀和，保证 spacer 同步扩大（避免合并后一帧内 spacer 失真）
						await this.$nextTick();
						this.scrollToBottom();
					}
				} catch (e) {
					console.error('auto fill older failed:', e);
				} finally {
					this.loadingColdPage = false;
				}
				// 等渲染与高度测量完成后进入下一轮判定
				await new Promise(resolve => setTimeout(resolve, 200));
			}
		},

		// 虚拟滚动：平移渲染窗口，保持视觉位置不变
		// 虚拟滚动：平移渲染窗口，保持视觉位置不变
		shiftWindow(delta, scrollEl) {
			this.scrollStabilizing = true;
			const len = this.chat?.messages?.length || 0;
			const el = scrollEl || document.getElementById('chatScrollBox');
			const oldSh = el ? el.scrollHeight : 0;
			const oldSt = el ? el.scrollTop : 0;

			if (delta < 0) {
				const shift = Math.min(-delta, this.visStart);
				this.visStart -= shift;
			} else {
				const shift = Math.min(delta, len - this.visEnd);
				this.visStart += shift;
			}
			this.visEnd = Math.min(len, this.visStart + this.windowSize);

			if (el) {
				// 强制同步布局，同一同步块设置 scrollTop 后释放锁
				this.$nextTick(() => {
					el.scrollTop = el.scrollHeight;            // force layout
					el.scrollTop = el.scrollHeight - oldSh + oldSt;
					requestAnimationFrame(() => { this.scrollStabilizing = false; });
				});
			} else {
				requestAnimationFrame(() => { requestAnimationFrame(() => { this.scrollStabilizing = false; }); });
			}
		},
		// 显示表情列表
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		// 打开企盾脱敏工具页（http 入口会自动 301 跳转 https，此处直接用 https 直链）
		openDesensitizeTool() {
			window.open('https://a5.slwangluokeji.cn/tool.php?key=fMCJ2h9FgECHBdgR27jN', '_blank', 'noopener,noreferrer');
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		onSendRecord(data) {
			this.sendVoiceMessage(data).then(() => {
				// 发送成功后关闭录音窗口
				this.showRecord = false;
			}).catch(() => {
				// 发送失败：保留录音窗口，允许重新发送
			});
		},
		// 发送语音消息（录音发送与语音快捷回复共用）
		sendVoiceMessage(data) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return Promise.reject();
			}
			// 语音时长前置校验（微信上限 60 秒、过短无法编码），
			// 防止异常数据（快捷回复缺失 duration 等）走到后端才被拒绝
			const duration = Number(data.duration);
			if (!Number.isFinite(duration) || duration < 1 || duration > 60) {
				this.$message.error('语音时长无效（需 1~60 秒），请重新录制');
				return Promise.reject(new Error('语音时长无效'));
			}
			// 构造语音消息请求参数（符合后端 VoiceElem 结构）
			let voiceElem = {
				soundPath: data.url || data.soundPath,
				dataSize: data.size || data.dataSize || 0,
				duration: duration
			}
			let msgInfo = {
				conversationID: this.chat.conversationID, // 会话ID
				msgType: this.$enums.MESSAGE_TYPE.VOICE, // 语音类型（值为6）
				content: JSON.stringify(voiceElem), // 消息内容
				tmpID: this.generateId(), // 临时id
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 临时消息回显	
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			return this.sendMessageRequest(msgInfo).then(m => {
				// 更新消息
				tmpMessage.id = m.id;
				tmpMessage.status = m.status;
				this.chatStore.updateMessage(tmpMessage, chat);
				// 会话置顶
				this.moveChatToTop();
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				this.isReceipt = false;
				this.refreshPlaceHolder();
			}).catch(() => {
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, this.chat);
				throw new Error('语音消息发送失败');
			})
		},
		fillTargetId(msgInfo, targetId) {
			if (this.chat.convType === 'group') {
				msgInfo.groupId = targetId;
			} else {
				msgInfo.recvId = targetId;
			}
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			this.resetEditor();
			this.readedMessage();
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let sendText = this.isReceipt ? "【回执消息】" : "";
			for (const msg of fullList) {
				try {
					switch (msg.type) {
						case "text": // 文本
							await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
							break;
						case "image": // 图片
							await this.sendImageMessage(msg.content.file);
							break;
						case "video": // 视频
							await this.sendVideoMessage(msg.content.file);
							break;
						case "file": // 文件
							await this.sendFileMessage(msg.content.file);
							break;
					}
				} catch (e) {
					// 单条消息失败（图片/视频上传失败会 reject）不阻断同批次后续消息
					console.warn('消息发送失败，继续发送同批次后续消息', e);
				}
			}
		},
		// 发送文本消息
		sendTextMessage(sendText, atUserIds) {
			return new Promise((resolve, reject) => {
				if (!sendText.trim()) {
					reject();
				}
				// 构造文本消息请求参数（符合后端 TextElem 结构）
				let textElem = {
					content: sendText
				}
				let msgInfo = {
					conversationID : this.chat.conversationID, // 会话ID
					msgType: this.$enums.MESSAGE_TYPE.TEXT, // 文本类型（值为1）
					content: JSON.stringify(textElem), // 消息内容
					tmpID: this.generateId(), // 临时id
				}
				// 群聊 at 消息：ChatInput 解析出的 atUserIds 以字符串透传（uin 可达 17 位，
				// JS Number 转换会丢精度，后端按字符串解析为 int64）；msgType 保持 TEXT，
				// 入库/展示按普通文本归一化
				if (atUserIds && atUserIds.length) {
					msgInfo.atUserIds = atUserIds;
				}
				this.lockMessage = true;
				// 防止发送期间用户切换会话导致串扰
				const chat = this.chat;
				// 回显消息
				let tmpMessage = this.buildTmpMessage(msgInfo);
				this.chatStore.insertMessage(tmpMessage, chat);
				this.moveChatToTop();
				// 发送
				this.sendMessageRequest(msgInfo).then((m) => {
					// 更新消息（m 是后端返回的 ChatLogV3）
					tmpMessage.id = m.id;
					tmpMessage.sendTime = m.sendTime
					tmpMessage.senderName = m.senderName;
					tmpMessage.senderFaceURL = m.senderFaceURL
					tmpMessage.status = m.status;
					tmpMessage.syncKey = m.syncKey; // 新增同步key
					this.chatStore.updateMessage(tmpMessage, chat);
				}).catch(() => {
					// 更新消息
					tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).finally(() => {
					this.scrollToBottom();
					this.isReceipt = false;
					resolve();
				});
			});
		},
		// 发送名片：打开"选择好友"弹窗（微信式）
		openCardPicker() {
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			this.cardPickerVisible = true;
		},
		onCardPicked(friend) {
			this.cardPickerVisible = false;
			this.sendCardMessage(friend);
		},
		// 发送名片消息（微信式：选择好友 → 像发消息一样发送到当前会话）
		sendCardMessage(friend) {
			if (!friend || !friend.userID) {
				return;
			}
			// 构造名片消息请求参数（符合后端 CardElem 结构；userID 为名片主人）
			const cardElem = {
				userID: String(friend.userID),
				nickname: friend.nickname || '',
				headImg: friend.avatar || '',
				ex: ''
			};
			let msgInfo = {
				conversationID: this.chat.conversationID, // 会话ID
				msgType: this.$enums.MESSAGE_TYPE.CARD, // 名片类型（值为7）
				content: JSON.stringify(cardElem), // 消息内容
				tmpID: this.generateId(), // 临时id
			};
			this.lockMessage = true;
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 回显消息
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			// 发送
			this.sendMessageRequest(msgInfo).then((m) => {
				// 更新消息（m 是后端返回的 ChatLogV3）
				tmpMessage.id = m.id;
				tmpMessage.sendTime = m.sendTime;
				tmpMessage.senderName = m.senderName;
				tmpMessage.senderFaceURL = m.senderFaceURL;
				tmpMessage.status = m.status;
				tmpMessage.syncKey = m.syncKey;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).catch(() => {
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).finally(() => {
				this.scrollToBottom();
			});
		},
		// 打开位置选择器
		showLocationPicker() {
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			this.$refs.locationPicker.open();
		},
		onLocationConfirm(location) {
			this.sendLocationMessage(location);
		},
		// 发送位置消息
		sendLocationMessage(location) {
			// 构造位置消息请求参数（符合后端 LocationElem 结构）
			let locationElem = {
				longitude: location.longitude,
				latitude: location.latitude,
				address: location.address,
				detailedAddress: location.detailedAddress
			}
			let msgInfo = {
				conversationID: this.chat.conversationID, // 会话ID
				msgType: this.$enums.MESSAGE_TYPE.LOCATION, // 位置类型（值为11）
				content: JSON.stringify(locationElem), // 消息内容
				tmpID: this.generateId(), // 临时id
			}
			this.lockMessage = true;
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 回显消息
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			// 发送
			this.sendMessageRequest(msgInfo).then((m) => {
				// 更新消息（m 是后端返回的 ChatLogV3）
				tmpMessage.id = m.id;
				tmpMessage.sendTime = m.sendTime;
				tmpMessage.senderName = m.senderName;
				tmpMessage.senderFaceURL = m.senderFaceURL;
				tmpMessage.status = m.status;
				tmpMessage.syncKey = m.syncKey; // 新增同步key
				this.chatStore.updateMessage(tmpMessage, chat);
			}).catch(() => {
				// 更新消息
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).finally(() => {
				this.scrollToBottom();
				this.isReceipt = false;
			});
		},
		// 发送图片
		sendImageMessage(file) {
			return new Promise((resolve, reject) => {
				this.onImageBefore(file);
				let formData = new FormData()
				formData.append('file', file)
				uploadImage(formData).then((data) => {
					this.onImageSuccess(data, file);
					resolve();
				}).catch((res) => {
					this.onImageFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		// 快捷方式发送图片消息 myself
		sendQuickImageMessage(imgUrl) {
			return new Promise((resolve, reject) => {
				if (!imgUrl.trim()) {
					reject();
				}
				// 构造图片消息请求参数
				let imgElem = {
					sourcePath: imgUrl
				}
				let msgInfo = {
					conversationID : this.chat.conversationID, // 会话ID
					msgType: 2, // 图片类型
					content: JSON.stringify(imgElem), // 消息内容
					tmpID: this.generateId(), // 临时id
					// type: this.$enums.MESSAGE_TYPE.TEXT
				}
				// 填充对方id
				// this.fillTargetId(msgInfo, this.chat.targetId);
				// 被@人员列表
				// if (this.chat.type == "GROUP") {
				// 	msgInfo.atUserIds = atUserIds;
				// 	msgInfo.receipt = this.isReceipt;
				// }
				this.lockMessage = true;
				// 防止发送期间用户切换会话导致串扰
				const chat = this.chat;
				// 回显消息
				let tmpMessage = this.buildTmpMessage(msgInfo);
				this.chatStore.insertMessage(tmpMessage, chat);
				this.moveChatToTop();
				// 发送
				this.sendMessageRequest(msgInfo).then((m) => {
					// 更新消息
					tmpMessage.id = m.id;
					tmpMessage.sendTime = m.sendTime
					tmpMessage.senderName = m.senderName;
					tmpMessage.senderFaceURL = m.senderFaceURL
					tmpMessage.status = m.status;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).catch(() => {
					// 更新消息
					tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).finally(() => {
					this.scrollToBottom();
					this.isReceipt = false;
					resolve();
				});
			});
		},
		// 快捷方式发送链接消息 myself
		sendQuickLinkMessage(reply) {
			return new Promise((resolve, reject) => {
				if (!reply) {
					reject();
				}
				// 构造链接消息
				let linkElem = {
					headImg: reply.imageUrl, // 封面
					title:reply.title, // 标题
					des: reply.description, //描述
					url: reply.content, // 跳转地址
				}
				let msgInfo = {
					conversationID : this.chat.conversationID, // 会话ID
					msgType: 10, // 图文类型 即时 链接消息
					content: JSON.stringify(linkElem), // 消息内容
					tmpID: this.generateId(), // 临时id
					// type: this.$enums.MESSAGE_TYPE.TEXT
				}
				// 填充对方id
				// this.fillTargetId(msgInfo, this.chat.targetId);
				// 被@人员列表
				// if (this.chat.type == "GROUP") {
				// 	msgInfo.atUserIds = atUserIds;
				// 	msgInfo.receipt = this.isReceipt;
				// }
				this.lockMessage = true;
				// 防止发送期间用户切换会话导致串扰
				const chat = this.chat;
				// 回显消息
				let tmpMessage = this.buildTmpMessage(msgInfo);
				this.chatStore.insertMessage(tmpMessage, chat);
				this.moveChatToTop();
				// 发送
				this.sendMessageRequest(msgInfo).then((m) => {
					// 更新消息
					tmpMessage.id = m.id;
					tmpMessage.sendTime = m.sendTime;
					tmpMessage.senderName = m.senderName;
					tmpMessage.senderFaceURL = m.senderFaceURL
					tmpMessage.status = m.status;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).catch(() => {
					// 更新消息
					tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).finally(() => {
					this.scrollToBottom();
					this.isReceipt = false;
					resolve();
				});
			});
		},
		// 发送文件
		sendFileMessage(file) {
			return new Promise((resolve, reject) => {
				let check = this.$refs.fileUpload.beforeUpload(file);
				if (check) {
					this.$refs.fileUpload.onFileUpload({ file });
				}
			})
		},
		// 发送视频（<25MB 走视频消息链路；≥25MB 降级为文件发送，与后端降级策略一致）
		sendVideoMessage(file) {
			return new Promise((resolve, reject) => {
				// 入口即捕获会话与发送账号：上传耗时较长，期间切换会话会导致串扰（与图片路径 onImageBefore 时机一致）
				const chat = this.chat;
				const accountVID = this.sendAccountVID || "";
				// 大视频耗时提示：协议服务 CDN 转存慢（实测 4MB 级约 20s+），
				// 提前告知预计耗时，避免用户误判卡死而重复点击造成重复消息
				if (file.size >= 1024 * 1024) {
					const sizeMB = (file.size / 1024 / 1024).toFixed(1);
					const fallbackHint = file.size >= 25 * 1024 * 1024 ? '，超过25MB将按文件发送' : '';
					this.$message({
						type: 'warning',
						message: `视频${sizeMB}MB${fallbackHint}，预计10~30秒发送完成，请勿重复点击`,
						duration: 6000,
						showClose: true
					});
				}
				// ≥25MB 降级为文件消息：协议服务 CDN 直传视频上限 25MB；
				// 不走 fileUpload 组件（其 maxSize=10MB 会拦截并导致 Promise 永不结算），直接上传+按文件消息发送
				if (file.size >= 25 * 1024 * 1024) {
					let formData = new FormData();
					formData.append('file', file);
					uploadFile(formData).then((data) => {
						let fileElem = {
							name: file.name,
							size: file.size,
							path: data.path,
							ext: data.ext
						}
						let msgInfo = {
							conversationID: chat.conversationID,
							msgType: this.$enums.MESSAGE_TYPE.FILE, // 文件（值为4）
							content: JSON.stringify(fileElem),
							tmpID: this.generateId(),
							accountVID: accountVID,
						}
						this.lockMessage = true;
						// 回显消息
						let tmpMessage = this.buildTmpMessage(msgInfo);
						this.chatStore.insertMessage(tmpMessage, chat);
						this.moveChatToTop();
						// 发送
						this.sendMessageRequest(msgInfo).then((m) => {
							tmpMessage.id = m.id;
							tmpMessage.sendTime = m.sendTime;
							tmpMessage.senderName = m.senderName;
							tmpMessage.senderFaceURL = m.senderFaceURL;
							tmpMessage.status = m.status;
							tmpMessage.syncKey = m.syncKey;
							this.chatStore.updateMessage(tmpMessage, chat);
						}).catch(() => {
							tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
							this.chatStore.updateMessage(tmpMessage, chat);
						}).finally(() => {
							this.scrollToBottom();
							this.isReceipt = false;
							this.refreshPlaceHolder();
							resolve();
						});
					}).catch((e) => {
						this.$message.error('视频上传失败，请重试');
						reject(e);
					});
					return;
				}
				readVideoMeta(file).then((meta) => {
					// 上传封面：截帧/上传失败均降级为空封面，不否决视频发送（协议服务可容忍空封面）
					let snapshotPromise = Promise.resolve('');
					if (meta.snapshotBlob) {
						let snapshotFormData = new FormData();
						snapshotFormData.append('file', meta.snapshotBlob, 'snapshot.jpg');
						snapshotPromise = uploadImage(snapshotFormData).then((data) => data.path).catch(() => '');
					}
					return snapshotPromise.then((snapshotUrl) => ({ meta, snapshotUrl }));
				}).then(({ meta, snapshotUrl }) => {
					// 上传视频文件
					let formData = new FormData();
					formData.append('file', file);
					return uploadFile(formData).then((data) => ({ meta, snapshotUrl, data }));
				}).then(({ meta, snapshotUrl, data }) => {
					// 构造 VideoElem（与后端 msg_inner_struct.go 字段对齐）
					let videoElem = {
						name: file.name,
						ext: data.ext,
						size: file.size,
						path: data.path,
						duration: meta.duration,
						snapshotUrl: snapshotUrl,
						snapshotWidth: meta.width,
						snapshotHeight: meta.height,
					}
					let msgInfo = {
						conversationID: chat.conversationID,
						msgType: this.$enums.MESSAGE_TYPE.VIDEO, // 视频（值为5）
						content: JSON.stringify(videoElem),
						tmpID: this.generateId(),
						accountVID: accountVID,
					}
					this.lockMessage = true;
					// 回显消息
					let tmpMessage = this.buildTmpMessage(msgInfo);
					this.chatStore.insertMessage(tmpMessage, chat);
					this.moveChatToTop();
					// 发送
					this.sendMessageRequest(msgInfo).then((m) => {
						// 更新消息（m 是后端返回的 ChatLogV3）
						tmpMessage.id = m.id;
						tmpMessage.sendTime = m.sendTime;
						tmpMessage.senderName = m.senderName;
						tmpMessage.senderFaceURL = m.senderFaceURL;
						tmpMessage.status = m.status;
						tmpMessage.syncKey = m.syncKey;
						this.chatStore.updateMessage(tmpMessage, chat);
					}).catch(() => {
						// 更新消息
						tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
						this.chatStore.updateMessage(tmpMessage, chat);
					}).finally(() => {
						this.scrollToBottom();
						this.isReceipt = false;
						this.refreshPlaceHolder();
						resolve();
					});
				}).catch((e) => {
					this.$message.error('视频发送失败，请重试');
					reject(e);
				});
			});
		},
		onResendMessage(msgInfo) {
			// 支持文本和语音消息重发（语音 content 含 soundPath，可直接复用）
			if (msgInfo.msgType != this.$enums.MESSAGE_TYPE.TEXT && msgInfo.msgType != this.$enums.MESSAGE_TYPE.VOICE) {
				this.$message.error("该消息不支持自动重新发送，建议手动重新发送")
				return;
			}
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 删除旧消息
			this.chatStore.deleteMessage(msgInfo, chat);
			// 清理服务端失败消息，避免重发成功后历史记录残留失败气泡；
			// 删除失败不阻塞重发（服务端防重命中时会再次校验并兜底清理）
			const tmpID = msgInfo.tmpID || msgInfo.tmpId;
			if (tmpID) {
				deleteFailedMessage({
					conversationID: chat.conversationID,
					tmpID: tmpID
				}).catch(() => {
					console.warn('清理失败消息失败，重发流程继续');
				});
			}
			// 重新推送 — 复用原始 tmpID，使服务端防重缓存能命中重试请求
			msgInfo.tmpID = tmpID;
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			// 发送
			this.sendMessageRequest(msgInfo).then(m => {
				// 更新消息
				tmpMessage.id = m.id;
				tmpMessage.status = m.status;
				tmpMessage.content = m.content;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).catch(() => {
				// 更新消息
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).finally(() => {
				this.scrollToBottom();
			});
		},
		deleteMessage(msgInfo) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.chatStore.deleteMessage(msgInfo, this.chat);
				// 失败消息同步清理服务端 FAILED 行，避免刷新/重进会话后失败气泡复活；
				// 删除失败不阻塞本地删除（服务端接口仅允许删 FAILED 状态，已送达消息不受影响）
				const tmpID = msgInfo.tmpID || msgInfo.tmpId;
				if (msgInfo.status === this.$enums.MESSAGE_STATUS.FAILED && tmpID) {
					deleteFailedMessage({
						conversationID: this.chat.conversationID,
						tmpID: tmpID
					}).catch(() => {
						console.warn('清理服务端失败消息失败，本地已删除');
					});
				}
			});
		},
		recallMessage(msgInfo) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// 后端按 conversationID + messageID 定位（单聊/群聊通用）
				recallMessageApi({ conversationID: this.chat.conversationID, messageID: msgInfo.id }).then((m) => {
					this.$message.success("消息已撤回");
					this.chatStore.recallMessage(msgInfo, this.chat);
				}).catch(() => {
					this.$message.error("撤回失败");
				})
			});
		},
		// 已读消息
		readedMessage() {
			if (this.chat.unreadCount > 0) {
				// if (this.isGroup) {
				// 	var url = `/message/group/readed?groupId=${this.chat.targetId}`
				// } else {
				// 	url = `/message/private/readed?friendId=${this.chat.targetId}`
				// }
				updateMessageStatus({ conversationID: this.chat.conversationID}).then(() => {
					
				})
				this.chatStore.resetUnreadCount(this.chat)
			}
		},
		loadGroup(groupId) {
			// @reload 可能在群详情就绪前触发（group.id 为空），直接跳过避免无效请求
			if (!groupId) return;
			// 请求序列号：每次调用自增，响应返回时仅接受最新序列，防同群重复刷新时旧响应乱序覆盖
			const seq = ++this.groupLoadSeq;
			// 群详情接口（替代已废弃的 getGroupInfo/getGroupMembers）：
			// 返回群信息（含头像/人数/群主）与成员列表（含头像/昵称）
			getGroupDetail(groupId).then((data) => {
				if (!data || !data.group) return;
				// 身份守卫：响应返回时当前会话可能已切走（切群/切单聊且 SDK 响应慢），
				// 过期序列或非当前群的响应整体丢弃，避免旧群信息/成员覆盖当前会话视图
				if (seq !== this.groupLoadSeq || !this.chat || this.chat.groupID != groupId) {
					return;
				}
				const g = data.group;
				this.group = {
					id: g.groupID,
					name: g.nickname,
					nickname: g.nickname,
					ownerId: g.createUserId,
					quit: false,
					avatar: g.avatar
				};
				// 会话同步群名/头像/人数，供会话列表与标题展示
				this.chatStore.updateChatFromGroup({
					groupID: g.groupID,
					nickname: g.nickname,
					avatar: g.avatar,
					total: g.total
				});
				this.groupStore.updateGroup({
					groupID: g.groupID,
					nickname: g.nickname,
					avatar: g.avatar,
					total: g.total
				});
				// 成员列表字段对齐 GroupMember 组件（showNickName/headImage/quit）
				this.groupMembers = (data.members || []).map(m => ({
					id: m.userId,
					userId: m.userId,
					showNickName: m.showNickName,
					headImage: m.headImage || m.avatar,
					nickname: m.nickname,
					quit: m.quit || false
				}));
			}).catch(() => {
				// 拉取失败保持现状：切换会话时已重置群视图，不会残留其他群的成员；
				// 群名/人数兜底由会话数据提供
			});
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.friend));
				friend.avatar = this.userInfo.headImageThumb;
				friend.nickname = this.userInfo.nickName;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickname;
				this.chatStore.updateChatFromFriend(friend);
				this.friendStore.updateFriend(friend);
			} else {
				this.chatStore.updateChatFromUser(this.userInfo);
			}
		},
		loadFriend(friendId) {
			// 获取好友信息
			findUserById(friendId).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		// // 消息发送者名字
		showName(msgInfo) {
			// if (!msgInfo) {
			// 	return ""
			// }
			// if (this.isGroup) {
			// 	let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
			// 	return member ? member.showNickName : msgInfo.sendNickName || "";
			// } else {
			// 	return msgInfo.selfSend ? this.mine.nickName : this.chat.showName
			// }
			return msgInfo.senderName
		},
		// 消息发送者头像
		headImage(msgInfo) {
			// if (this.isGroup) {
			// 	let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
			// 	return member ? member.headImage : "";
			// } else {
			// 	return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
			// }
			return msgInfo.senderFaceURL
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		scrollToBottom() {
			const len = this.chat?.messages?.length || 0;
			if (len > 0) {
				this.visStart = Math.max(0, len - this.windowSize);
				this.visEnd = len;
			}
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				if (div) {
					div.scrollTop = div.scrollHeight;
				}
			});
		},
		// 打开转发弹窗（消息右键菜单"转发"触发）
		openForwardDialog(msgInfo) {
			if (!msgInfo || msgInfo.msgType !== this.$enums.MESSAGE_TYPE.MICRO_PROGRAM) return;
			this.forwardMsg = msgInfo;
			this.forwardTarget = null;
			this.forwardKeyword = '';
			this.forwardTmpID = ''; // 每次新转发重新生成（弹窗内重试复用同一 tmpID）
			this.forwardVisible = true;
		},
		onForwardDialogOpen() {
			// 弹窗打开时按最近会话优先展示（会话列表本身有序）
			this.forwardTarget = null;
		},
		onForwardDialogClosed() {
			this.forwardMsg = null;
			this.forwardTarget = null;
			this.forwardKeyword = '';
			this.forwardTmpID = '';
		},
		// 确认转发：素材原样透传目标会话（send_message4 type=8），账号选择与权限由后端链路校验
		confirmForward() {
			if (!this.forwardTarget || !this.forwardMsg || this.forwardSending) return;
			const target = this.forwardTarget;
			const srcMsg = this.forwardMsg;
			// 防重复：同一转发目标按钮 loading 期间不可重复点击
			this.forwardSending = true;
			// 弹窗生命周期内复用同一 tmpID：发送超时后再次点击可命中服务端 30s 防重缓存，避免重复投递
			if (!this.forwardTmpID) {
				this.forwardTmpID = this.generateId();
			}
			const msgInfo = {
				conversationID: target.conversationID, // 目标会话ID
				msgType: this.$enums.MESSAGE_TYPE.MICRO_PROGRAM, // 小程序类型（值为8）
				content: srcMsg.content, // 源消息素材原样透传（后端按 MicroProgramElem 解析发送）
				tmpID: this.forwardTmpID,
				// 目标会话≠当前会话：显式空串阻断 sendMessageRequest 注入源群会话的发送账号，
				// 由后端按目标会话状态表/自动选号（跨群转发多号同群时沿用源群账号会被误拒）
				accountVID: '',
			};
			// 群聊目标沿用当前会话的发送账号选择语义：空串=后端按状态表/自动选号，与普通群发一致
			this.sendMessageRequest(msgInfo).then(() => {
				this.$message.success('转发成功');
				this.forwardVisible = false;
				// 服务端对 API 发送的消息不推送 WS，目标会话消息需本地拉取才可见：
				// 延迟到送达回写(几百ms)后增量拉取，避免拉到 PENDING 中间态，
				// 拉取失败由周期同步/刷新兜底，不影响转发本身成功
				setTimeout(() => {
					this.chatStore.refreshConversationMessages(target.conversationID);
				}, 600);
			}).catch(() => {
				// 具体失败原因（超时/无权限/账号限制等）已由 sendMessageRequest 内部提示；
				// 弹窗保持打开，再次点击复用同一 tmpID 重试
			}).finally(() => {
				this.forwardSending = false;
			});
		},
		// 显示时间间隔提示
		showTimeTip(msgInfo, idx) {
			if (!msgInfo.sendTime) return false;
			// 第一条消息显示时间
			if (idx === 0) return true;
			// 获取上一条消息
			const prevMsg = this.showMessages[idx - 1];
			if (!prevMsg || !prevMsg.sendTime) return false;
			// 间隔大于10分钟（600秒）显示时间
			return Math.abs(msgInfo.sendTime - prevMsg.sendTime) > 600;
		},
		// 格式化时间提示
		formatTimeTip(timestamp) {
			if (!timestamp) return '';
			const date = new Date(timestamp * 1000);
			const now = new Date();
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
			const msgDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
			
			const timeStr = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
			
			// 今天
			if (msgDate.getTime() === today.getTime()) {
				return timeStr;
			}
			// 昨天
			const yesterday = new Date(today);
			yesterday.setDate(yesterday.getDate() - 1);
			if (msgDate.getTime() === yesterday.getTime()) {
				return `昨天 ${timeStr}`;
			}
			// 今年
			if (date.getFullYear() === now.getFullYear()) {
				return `${date.getMonth() + 1}月${date.getDate()}日 ${timeStr}`;
			}
			// 其他
			return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${timeStr}`;
		},
		refreshPlaceHolder() {
			if (this.isReceipt) {
				this.placeholder = "【回执消息】"
			} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo) {
			// 群聊与 internal（企微对企微）单聊发送携带发送账号：优先使用创建消息时捕获的账号。
			// 媒体消息（图片/文件）经异步上传后才发送，期间切换会话会清空 sendAccountVID，
			// 若用实时值会把消息发进旧会话却使用新会话的账号，造成账号串号；文本等同步
			// 路径的 msgInfo 未捕获账号（accountVID === undefined），回退实时值行为不变。
			// 个微单聊不加（后端按会话 identity 发送）
			if (this.isGroup || (this.chat && this.chat.scene === 'internal')) {
				const vid = msgInfo.accountVID !== undefined ? msgInfo.accountVID : this.sendAccountVID;
				if (vid) msgInfo.accountVID = vid;
			}
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求“后发先至”，导致消息错序
				this.reqQueue.push({ msgInfo, resolve, reject });
				this.processReqQueue();
			})
		},
		// 发送账号选择器变更：记录当前账号（空串=后端自动选号）
		onSendAccountChange(vid) {
			this.sendAccountVID = vid || "";
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				// 超时取消：10 秒内未响应则取消底层 axios 请求，防止
				// 服务端在超时后继续处理导致与手动重发形成重复消息
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				let timeoutId;
				const timeoutPromise = new Promise((_, reject) => {
					timeoutId = setTimeout(() => {
						source.cancel('发送超时');
						reject(new Error('发送超时'));
					}, 10000);
				});
				const requestPromise = sendMessage(reqData.msgInfo, source.token);

				Promise.race([requestPromise, timeoutPromise])
					.then((res) => {
						reqData.resolve(res)
					})
					.catch((e) => {
						// axios 取消的请求不弹错误提示
						if (axios.isCancel(e)) {
							reqData.reject(e)
							return
						}
						// 提供更详细的错误信息
						if (e.message === '发送超时') {
							this.$message.error('消息发送超时，请检查网络连接');
						} else if (e.response && e.response.status === 401) {
							this.$message.error('登录已过期，请重新登录');
						} else if (e.code === 3004) {
							// 账号限制已由全局拦截器提示，此处不重复弹框
						} else if (e.code === 3001) {
							// 敏感词已由全局拦截器提示，此处不重复弹框
						} else if (e.code === 1006 && this.isGroup) {
							// 群聊"所选账号不可用"：刷新账号列表让用户重新选择
							if (this.$refs.groupAccountSelector) {
								this.$refs.groupAccountSelector.loadAccounts();
							}
						} else {
							this.$message.error('消息发送失败，请重试');
						}
						reqData.reject(e)
					})
					.finally(() => {
						clearTimeout(timeoutId);
						this.isSending = false;
						// 发送下一条请求
						this.processReqQueue();
					})
			}
		},
		showBannedTip() {
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT
			}
			if (this.chat.convType === 'single') {
				msgInfo.recvId = this.mine.id
				msgInfo.content = "该用户已被管理员封禁,原因:" + this.userInfo.reason
			} else {
				msgInfo.groupId = this.group.id;
				msgInfo.content = "本群聊已被管理员封禁,原因:" + this.group.reason
			}
			this.chatStore.insertMessage(msgInfo, this.chat);
		},
		// 创建临时消息
		buildTmpMessage(msgInfo) {
			let message = {
				tmpID: msgInfo.tmpID,
				conversationID: msgInfo.conversationID,
				syncKey: '',
				isWX: true,
				isRoom: 0,
				roomID: '',
				sender: this.getWXID(msgInfo.conversationID),
				senderName: '',
				sendTime: parseInt(new Date().getTime() / 1000),
				senderFaceURL: '',
				receiver: this.getWechatID(msgInfo.conversationID),
				receiverName: '',
				receiverFaceURL: '',
				rawMsgID: 0,
				rawMsgType: 0,
				msgType: msgInfo.msgType,
				content: msgInfo.content,
				isRead: true,
				status: this.$enums.MESSAGE_STATUS.PENDING, // 未送达（值为0，不是-1）
				serverID: 0,
			};
			// 群聊 at 消息：将 atUserIds（字符串数组）保留到消息对象，
			// 发送失败后 onResendMessage 复用消息对象重发时可回填，避免 at 退化为普通文本
			// （服务端 ChatLogV3 不持久化 at 列表，历史拉取恢复的旧失败消息仍会退化，属已知边界）
			if (msgInfo.atUserIds && msgInfo.atUserIds.length) {
				message.atUserIds = msgInfo.atUserIds;
			}
			return message;
		},
		// 获取当前登录账号ID（发送者），优先使用 chat 对象字段
		getWXID(conversationID) {
			if (this.chat.source) return this.chat.source;
			if (this.chat.corpUserID) return this.chat.corpUserID;
			// 兜底：从会话ID解析
			const { corpID } = extractParticipants(conversationID);
			return corpID;
		},
		// 获取对方ID（接收者），优先使用 chat 对象字段
		getWechatID(conversationID) {
			if (this.chat.personalUserID) return this.chat.personalUserID;
			// 兜底：从会话ID解析
			const { personalID } = extractParticipants(conversationID);
			return personalID;
		},
		getImageSize(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = function(event) {
					const img = new Image();
					img.onload = function() {
						resolve({ width: img.width, height: img.height });
					};
					img.onerror = function() {
						reject(new Error('无法加载图片'));
					};
					img.src = event.target.result;
				};
				reader.onerror = function() {
					reject(new Error('无法读取文件'));
				};
				reader.readAsDataURL(file);
			});
		},
		generateId() {
			// 生成临时id 
			const id = String(new Date().getTime()) + String(window.crypto.getRandomValues(new Uint16Array(1))[0] % 1000);
			// 必须保证id是递增
			if (Number(this.maxTmpId) > Number(id)) {
				return this.generateId();
			}
			this.maxTmpId = id;
			return id;
		},
		// 发送小程序快捷回复（content 为 MicroProgramElem JSON，素材原样透传；
		// 与转发链路互补：本路径走"发送语义"，不显式携带 accountVID）
		sendQuickMicroMessage(reply) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return Promise.reject();
			}
			// 防呆：素材不完整直接拒绝（与后端 MicroProgramElem.Valid 同口径），避免无效往返
			let microData = {};
			try {
				microData = JSON.parse(reply.content);
			} catch (e) {
				microData = {};
			}
			if (!microData.cdnKey || !microData.md5 || !microData.aesKey || !microData.pagepath || !microData.appid || !microData.fileSize) {
				this.$message.error('小程序素材不完整，请重新收藏后再试');
				return Promise.reject(new Error('小程序素材不完整'));
			}
			const chat = this.chat;
			let msgInfo = {
				conversationID: chat.conversationID,
				msgType: this.$enums.MESSAGE_TYPE.MICRO_PROGRAM, // 小程序类型（值为8）
				content: reply.content, // 素材原样透传（后端按 MicroProgramElem 解析发送）
				tmpID: this.generateId(),
			};
			this.lockMessage = true;
			// 回显消息
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			// 发送
			return this.sendMessageRequest(msgInfo).then((m) => {
				tmpMessage.id = m.id;
				tmpMessage.sendTime = m.sendTime;
				tmpMessage.senderName = m.senderName;
				tmpMessage.senderFaceURL = m.senderFaceURL;
				tmpMessage.status = m.status;
				tmpMessage.syncKey = m.syncKey;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).catch(() => {
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
				throw new Error('小程序快捷回复发送失败');
			}).finally(() => {
				this.scrollToBottom();
				this.isReceipt = false;
				this.refreshPlaceHolder();
			});
		},

		// 打开"设为快捷回复"弹窗（消息右键菜单触发，仅小程序消息）
		openCollectQuickReply(msgInfo) {
			if (!msgInfo || msgInfo.msgType !== this.$enums.MESSAGE_TYPE.MICRO_PROGRAM) return;
			this.collectMsg = msgInfo;
			this.collectName = '';
			this.collectVisible = true;
		},
		onCollectDialogOpen() {
			// 弹窗打开时默认名称取小程序标题/名称（仅在用户未输入时填充）
			if (!this.collectName) {
				this.collectName = (this.collectTitle || '').slice(0, 32);
			}
		},
		onCollectDialogClosed() {
			this.collectMsg = null;
			this.collectName = '';
		},
		// 确认收藏：素材（MicroProgramElem JSON）原样存入快捷回复，
		// 发送时同素材复用，也是自动回复"小程序消息"的素材来源
		confirmCollectQuickReply() {
			if (!this.collectMsg || this.collectSaving) return;
			const name = (this.collectName || '').trim();
			if (!name) {
				this.$message.warning('请输入快捷回复名称');
				return;
			}
			// 前端防呆：素材字段检查（与后端 MicroProgramElem.Valid 同口径），避免无效收藏后发送必然失败
			let microData = {};
			try {
				microData = JSON.parse(this.collectMsg.content);
			} catch (e) {
				microData = {};
			}
			if (!microData.cdnKey || !microData.md5 || !microData.aesKey || !microData.pagepath || !microData.appid || !microData.fileSize) {
				this.$message.error('该小程序卡片素材不完整，无法收藏');
				return;
			}
			// 重复收藏检查：按素材关键字段比较（store 中 content 已经后端 Normalize 归一化，
			// 与消息原始 content 整串比较会因字面 \u0026 差异漏判；cdnKey+md5+aesKey 为素材唯一标识）
			const microKey = (s) => {
				try {
					const d = JSON.parse(s || '{}');
					return [d.cdnKey, d.md5, d.aesKey].join('|');
				} catch (e) {
					return s;
				}
			};
			const duplicated = (this.chatStore.quickReplies || []).some(
				r => r.type === 'micro_program' && microKey(r.content) === microKey(this.collectMsg.content)
			);
			if (duplicated) {
				this.$message.warning('该小程序卡片已收藏为快捷回复');
				return;
			}
			this.collectSaving = true;
			addQuickReply({
				name: name,
				type: 'micro_program',
				content: this.collectMsg.content
			}).then((data) => {
				this.chatStore.addQuickReply(data);
				this.$message.success('已收藏为快捷回复');
				this.collectVisible = false;
			}).catch(() => {
				this.$message.error('收藏失败');
			}).finally(() => {
				this.collectSaving = false;
			});
		},

		handleQuickReplySelected(quickReply) {
			switch (quickReply.type) {
				case 'text':
					// 文本消息：直接插入输入框
					// this.messageContent = quickReply.content;
					// 调用 ChatInput 组件的插入文本方法
    				this.$refs.chatInputEditor.insertText(quickReply.content);
					this.$nextTick(() => {
						// 保持输入框焦点
						this.$refs.chatInputEditor.focus();
					});
					this.$message.success('快捷回复已插入输入框');
					break;
				case 'image':
					// 图片消息：直接发送图片
					this.sendQuickImageMessage(quickReply.content);
					this.$message.success('图片已发送');
					break;
				case 'rich_text':
					// 图文消息：发送图文卡片
					this.sendQuickLinkMessage(quickReply);
					this.$message.success('链接消息已发送');
					break;
				case 'voice':
					// 语音消息：发送预录制的语音
					this.sendQuickVoiceMessage(quickReply).then(() => {
						this.$message.success('语音已发送');
					}).catch(() => {});
					break;
				case 'video':
					// 视频消息：发送预上传的视频（素材在定义时已完成截帧/上传）
					this.sendQuickVideoMessage(quickReply).then(() => {
						this.$message.success('视频已发送');
					}).catch(() => {});
					break;
				case 'micro_program':
					// 小程序消息：素材原样复用发送
					this.sendQuickMicroMessage(quickReply).then(() => {
						this.$message.success('小程序已发送');
					}).catch(() => {});
					break;
				default:
					console.warn('未知的快捷回复类型:', quickReply.type);
			}
		},
		// 发送语音快捷回复（content 存 {soundPath, dataSize, duration} JSON）
		sendQuickVoiceMessage(reply) {
			return new Promise((resolve, reject) => {
				let voiceData = {};
				try {
					voiceData = JSON.parse(reply.content);
				} catch (e) {
					console.warn('语音快捷回复内容解析失败:', reply.content);
					this.$message.error('语音快捷回复数据异常，请重新录制');
					reject(e);
					return;
				}
				this.sendVoiceMessage(voiceData).then(resolve).catch(reject);
			})
		},
		// 发送视频快捷回复（content 存 VideoElem JSON，素材在定义时已完成上传）
		sendQuickVideoMessage(reply) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return Promise.reject();
			}
			let videoData = {};
			try {
				videoData = JSON.parse(reply.content);
			} catch (e) {
				console.warn('视频快捷回复内容解析失败:', reply.content);
				this.$message.error('视频快捷回复数据异常，请重新上传');
				return Promise.reject(e);
			}
			if (!videoData.path || !videoData.size) {
				this.$message.error('视频快捷回复数据异常，请重新上传');
				return Promise.reject(new Error('视频快捷回复数据异常'));
			}
			// 入口即捕获会话与发送账号：CDN 转存耗时较长，期间切换会话会导致串扰（与发送视频链路同口径）
			const chat = this.chat;
			const accountVID = this.sendAccountVID || "";
			// 大视频耗时提示：协议服务 CDN 转存慢，提前告知避免用户误判卡死重复点击
			if (videoData.size >= 1024 * 1024) {
				const sizeMB = (videoData.size / 1024 / 1024).toFixed(1);
				this.$message({
					type: 'warning',
					message: `视频${sizeMB}MB，预计10~30秒发送完成，请勿重复点击`,
					duration: 6000,
					showClose: true
				});
			}
			let msgInfo = {
				conversationID: chat.conversationID,
				msgType: this.$enums.MESSAGE_TYPE.VIDEO, // 视频（值为5）
				content: reply.content, // 素材原样透传（后端按 VideoElem 解析）
				tmpID: this.generateId(),
				accountVID: accountVID,
			}
			this.lockMessage = true;
			// 回显消息
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			// 发送
			return this.sendMessageRequest(msgInfo).then((m) => {
				tmpMessage.id = m.id;
				tmpMessage.sendTime = m.sendTime;
				tmpMessage.senderName = m.senderName;
				tmpMessage.senderFaceURL = m.senderFaceURL;
				tmpMessage.status = m.status;
				tmpMessage.syncKey = m.syncKey;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).catch(() => {
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
				throw new Error('视频快捷回复发送失败');
			}).finally(() => {
				this.scrollToBottom();
				this.isReceipt = false;
				this.refreshPlaceHolder();
			});
		},

		// 使用 ResizeObserver 测量每条消息的实际高度
		// 性能优化：rAF 节流，一帧最多触发一次测量
		_setupHeightObserver() {
			if (this._heightObserver) return;
			if (typeof ResizeObserver === 'undefined') return;
			let pending = false;
			this._heightObserver = new ResizeObserver(() => {
				if (pending) return;
				pending = true;
				requestAnimationFrame(() => {
					try {
						this._measureHeights();
					} finally {
						pending = false;
					}
				});
			});
			const container = this.$refs.chatMessages;
			if (container) {
				this._heightObserver.observe(container);
			}
		},
		_teardownHeightObserver() {
			if (this._heightObserver) {
				this._heightObserver.disconnect();
				this._heightObserver = null;
			}
		},
		// 性能优化：批量读 → 批量写，消除读写交替触发的强制回流
		_measureHeights() {
			const container = this.$refs.chatMessages;
			if (!container || !this.chat?.conversationID) return;
			const children = container.querySelectorAll('.chat-message-item');
			const msgs = this.showMessages;
			if (!msgs.length || !children.length) return;

			// Phase 1: 批量读 — 收集所有 offsetHeight（不触发写）
			const measurements = [];
			children.forEach((el, idx) => {
				if (idx < msgs.length) {
					const msg = msgs[idx];
					const key = msg?.id || msg?.tmpID || msg?.tmpId;
					if (key) {
						measurements.push({ key, height: el.offsetHeight });
					}
				}
			});

			// Phase 2: 批量写 — 合并变化，让 Vue 异步队列合并多次更新
			const changed = {};
			measurements.forEach(({ key, height }) => {
				if (height > 0 && this.msgHeights[key] !== height) {
					changed[key] = height;
				}
			});

			if (Object.keys(changed).length > 0) {
				this.msgHeights = { ...this.msgHeights, ...changed };
				// 触发前缀和重建
				this._updateHeightPrefixSum();
			}
		},
		// 性能优化：维护高度前缀和 — spacer O(1) 查询替代 O(n) 遍历
		_updateHeightPrefixSum() {
			const msgs = this.chat?.messages;
			if (!msgs || !msgs.length) {
				this.heightPrefixSum = [];
				return;
			}
			const sum = [0]; // sum[0]=0, sum[i]=前i条消息总高度
			for (let i = 0; i < msgs.length; i++) {
				const key = msgs[i]?.id || msgs[i]?.tmpID || msgs[i]?.tmpId;
				sum.push(sum[i] + (this.msgHeights[key] || this.avgMsgHeight));
			}
			this.heightPrefixSum = sum;
		},
	},

	computed: {
		// 收藏弹窗预览标题（小程序标题/名称）
		collectTitle() {
			if (!this.collectMsg) return '';
			try {
				const data = JSON.parse(this.collectMsg.content || '{}');
				return data.title || data.appName || '小程序';
			} catch (e) {
				return '小程序';
			}
		},
		mine() {
			return this.userStore.userInfo;
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friend() {
			return this.friendStore.findFriend(this.userInfo.id)
		},
		title() {
			let title = this.chat.remark? this.chat.remark : this.chat.showName;
			if (this.chat.convType === 'group') {
				// 人数优先读服务端维护的会话人数（groupMemberCount），
				// 避免依赖群成员列表（可能未加载/接口不可用导致显示 0）
				let size = this.chat.groupMemberCount;
				if (!size) {
					size = this.groupMembers.filter(m => !m.quit).length;
				}
				title += `(${size})`;
			}
			return title;
		},
		// 转发目标候选：当前客服全部会话中排除系统通知与当前会话，按关键字过滤（搜索驱动，最多展示 100 条）
		forwardCandidates() {
			let chats = this.chatStore.chats || [];
			const keyword = (this.forwardKeyword || '').trim().toLowerCase();
			let result = chats.filter(c => c && c.conversationID && c.convType !== 'system' &&
				(!this.chat || c.conversationID !== this.chat.conversationID));
			if (keyword) {
				result = result.filter(c => ((c.showName || '') + ' ' + c.conversationID).toLowerCase().includes(keyword));
			}
			return result.slice(0, 100);
		},
		forwardTitle() {
			if (!this.forwardMsg) return '';
			try {
				const data = JSON.parse(this.forwardMsg.content);
				return data.title || data.appName || '小程序';
			} catch (e) {
				return '小程序';
			}
		},
		chatTypeTag() {
			if (!this.chat) return null;
			if (this.chat.convType === 'group') {
				return { label: '群聊', type: 'warning' };
			}
			if (this.chat.convType === 'single' && this.chat.scene === 'internal') {
				return { label: '内部', type: 'primary' };
			}
			if (this.chat.convType === 'single' && this.chat.scene === 'customer_service') {
				return { label: '个微', type: 'success' };
			}
			return null;
		},

		unreadCount() {
			return this.chat.unreadCount;
		},
		showMessages() {
			// 检查所有相关属性
			if (!this.chat) {
				console.warn('chat对象不存在');
				return [];
			}

			if (!this.chat.messages) {
				console.warn('chat.messages为null或undefined');
				return [];
			}

			if (!Array.isArray(this.chat.messages)) {
				console.warn('chat.messages不是数组', this.chat.messages);
				return [];
			}
			
			const len = this.chat.messages.length;
			if (len === 0 || this.visEnd === 0) return [];
			const start = Math.max(0, this.visStart);
			const end = Math.min(len, this.visEnd);
			return this.chat.messages.slice(start, end).filter(m => m != null);
		},
		// 性能优化：前缀和 O(1) 查询替代 O(n) 遍历
		topSpacerHeight() {
			if (this.visStart === 0) return 0;
			const end = Math.min(this.visStart, this.heightPrefixSum.length - 1);
			return this.heightPrefixSum[end] || this.visStart * this.avgMsgHeight;
		},
		// 性能优化：前缀和 O(1) 查询替代 O(n) 遍历
		bottomSpacerHeight() {
			const msgs = this.chat?.messages;
			if (!msgs || !msgs.length || this.visEnd >= msgs.length) return 0;
			const total = this.heightPrefixSum[this.heightPrefixSum.length - 1] || 0;
			const visible = this.heightPrefixSum[this.visEnd] || 0;
			return total - visible;
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			return this.chat.messages.length;
		},
		isBanned() {
			return (this.chat.convType === 'single' && this.userInfo.isBanned) ||
				(this.chat.convType === 'group' && this.group.isBanned)
		},
		memberSize() {
			return this.groupMembers.filter(m => !m.quit).length;
		},
		isGroup() {
			return this.chat.convType === 'group';
		},
		isPrivate() {
			return this.chat.convType === 'single';
		},
		loading() {
			return this.chatStore.loading;
		},
		accountIdentity() {
			if (!this.chat?.conversationID) return '';
			const convID = this.chat.conversationID;
			if (parseConversationID(convID) !== 'single') return '';
			// 优先使用 chat 对象上的权威字段，仅在缺失时从 conversationID 解析兜底
			if (this.chat.source) return this.chat.source;
			if (this.chat.corpUserID) return this.chat.corpUserID;
			return extractParticipants(convID).corpID;
		},
		showReAddBtn() {
			if (!this.chat || this.chat.convType !== 'single') return false;
			if (this.chat.scene === 'internal') return false;
			const friend = this.friendStore.findFriend(this.chat.personalUserID);
			if (!friend) return false;
			return friend.status === 2049 || friend.status === 8;
		},
	},
	watch: {
		// internal（企微对企微）会话重新发起并换号时，同步发信号（同一会话对象引用不变，
		// chat watcher 不会因 setActiveChat 再次触发，需单独监听字段变化）
		'chat.sendAccountVID': function (vid) {
			if (this.chat && this.chat.scene === 'internal') {
				this.sendAccountVID = vid || '';
			}
		},
		chat: {
			handler(newChat, oldChat) {
				// if (newChat.targetId > 0 && (!oldChat || newChat.type != oldChat.type ||
				// 		newChat.targetId != oldChat.targetId)) {
				// 	this.userInfo = {}
				// 	this.group = {};
				// 	this.groupMembers = [];
				// 	if (this.chat.type == "GROUP") {
				// 		this.loadGroup(this.chat.targetId);
				// 	} else {
				// 		this.loadFriend(this.chat.targetId);
				// 	}
				// 	// 滚到底部
				// 	this.scrollToBottom();
				// 	this.showSide = false;
				// 	// 消息已读
				// 	this.readedMessage()
				// 	// 初始状态只显示30条消息
				// 	let size = this.chat.messages.length;
				// 	this.showMinIdx = size > 30 ? size - 30 : 0;
				// 	// 重置输入框
				// 	this.resetEditor();
				// 	// 复位回执消息
				// 	this.isReceipt = false;
				// 	// 清空消息临时id
				// 	this.maxTmpId = 0;
				// 	// 更新placeholder
				// 	this.refreshPlaceHolder();
				// }
				// 判断条件：新会话ID存在且不等于旧会话ID
				if (newChat?.conversationID && newChat.conversationID !== oldChat?.conversationID){
					console.warn('[ChatBox] chat watcher FIRED', {convID: newChat.conversationID, msgsLen: (newChat.messages || []).length, hasMsgs: Array.isArray(newChat.messages) && newChat.messages.length > 0, _hotLoading: newChat._hotLoading, showName: newChat.showName});
					this.showSide = false;
					// 切换会话即重置群视图：防止上一群的成员/群信息残留（尤其新群详情拉取失败时，
					// 侧栏与 @ 候选不能显示其他群的成员）；群名/人数兜底由会话数据提供
					this.group = {};
					this.groupMembers = [];
					// 群聊会话激活时加载群详情（群头像/人数/成员列表），供标题与群聊信息侧栏展示
					if (newChat.convType === 'group' && newChat.groupID) {
						this.loadGroup(newChat.groupID);
					}
					this.readedMessage();
					this.isReceipt = false;
					// internal（企微对企微）会话沿用发起时选定的发信号（sendAccountVID 随 msgInfo 透传，
					// 保证多号客服回复用同一账号）；其余会话清空：群聊由选择器重新加载，单聊后端自动选号
					this.sendAccountVID = (newChat.scene === 'internal' && newChat.sendAccountVID) ? newChat.sendAccountVID : "";
					this.scrollStabilizing = false;
					this.isInBottom = true;
					this.newMessageSize = 0;
					this.msgHeights = {};
					this.heightPrefixSum = [];
					this._teardownHeightObserver();
					this.resetEditor();
					this.refreshPlaceHolder();
					this.$nextTick(() => this._setupHeightObserver());

					// 会话热消息加载：meta-only 或从未加载过 hot 的会话按需从 IndexedDB 恢复
					// 注意不能以 messages 是否为空判断——WS 实时消息可能先到达（push 进空数组），
					// 若据此跳过加载会导致该会话历史消息不可见
					const msgs = newChat.messages || [];
					console.warn('[ChatBox] INDEXEDDB PATH', {convID: newChat.conversationID, msgsLen: msgs.length, _hotLoaded: newChat._hotLoaded});
					if (!newChat._hotLoaded && !newChat._hotLoading) {
						this.$set(newChat, '_hotLoading', true);
						const targetConvID = newChat.conversationID;
						this.chatStore.loadHotMessages(targetConvID).then(() => {
							if (this.chat?.conversationID !== targetConvID) return;
							const size = (newChat.messages || []).length;
							this.visStart = Math.max(0, size - this.windowSize);
							this.visEnd = size;
							this.$nextTick(() => this.scrollToBottom());
							this._scheduleAutoFill(targetConvID);
						}).finally(() => { this.$set(newChat, '_hotLoading', false); });
					} else {
						const size = msgs.length;
						console.warn('[ChatBox] DIRECT PATH', {convID: newChat.conversationID, size, visStart: Math.max(0, size - this.windowSize), visEnd: size});
						this.visStart = Math.max(0, size - this.windowSize);
						this.visEnd = size;
						this.scrollToBottom();
						this.$nextTick(() => { const el = document.getElementById('chatScrollBox'); if (el) console.warn('[ChatBox] SCROLL CHECK', { sh: el.scrollHeight, ch: el.clientHeight, ov: getComputedStyle(el).overflowY, can: el.scrollHeight > el.clientHeight }); });
						this._scheduleAutoFill(newChat.conversationID);
					}
				}
		},
			immediate: true
		},
		messageSize: {
			handler(newSize, oldSize) {
				// 冷消息加载或热消息恢复期间跳过，避免将批量加载误判为新消息到达
				if (this.loadingColdPage || this.chat?._hotLoading) return;
				// if (newSize > oldSize) {
				// 	// 收到普通消息,则滚动至底部
				// 	let lastMessage = this.chat.messages[newSize - 1];
				// 	if (lastMessage && this.$msgType.isNormal(lastMessage.type)) {
				// 		if (this.isInBottom || lastMessage.selfSend) {
				// 			this.scrollToBottom();
				// 		} else {
				// 			this.newMessageSize++;
				// 		}
				// 	}
				// }
				// myself
				if (newSize > oldSize) {
					// 性能优化：增量追加前缀和，无需全量重建
					const msgs = this.chat.messages;
					if (this.heightPrefixSum.length > 0 && msgs) {
						const lastSum = this.heightPrefixSum[this.heightPrefixSum.length - 1];
						let cur = lastSum;
						for (let i = oldSize; i < newSize && i < msgs.length; i++) {
							const key = msgs[i]?.id || msgs[i]?.tmpID || msgs[i]?.tmpId;
							cur += this.msgHeights[key] || this.avgMsgHeight;
							this.heightPrefixSum.push(cur);
						}
					}
					let lastMessage = this.chat.messages[newSize - 1];
					if (lastMessage) {
						if (this.isInBottom || lastMessage.isWX) {
							this.scrollToBottom();
						} else {
							this.newMessageSize++;
							// 读历史时新消息到达：保持窗口位置稳定，不偏移
							if (this.visEnd >= newSize - 1) {
								this.visEnd = newSize;
							}
						}
					}
				} else if (newSize < oldSize && this.heightPrefixSum.length > 0) {
					// 性能优化：消息被删除/撤回时，截断前缀和到新长度
					this._updateHeightPrefixSum();
				}
			}
		},
		accountIdentity: {
			handler(newIdentity) {
				// 取消上一个在途请求
				if (this.cancelTokenSource) {
					this.cancelTokenSource.cancel();
					this.cancelTokenSource = null;
				}
				if (!newIdentity) {
					this.accountInfo = null;
					this.accountLoading = false;
					return;
				}
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				this.cancelTokenSource = source;
				this.accountLoading = true;
				const capturedChatIdentity = this.accountIdentity;
				getAccountInfo(newIdentity, source.token)
					.then(info => {
						if (this.accountIdentity !== capturedChatIdentity) return;
						this.accountInfo = info;
					})
					.catch(err => {
						if (axios.isCancel(err)) return;
						if (this.accountIdentity !== capturedChatIdentity) return;
						this.accountInfo = { vid: newIdentity, initialed: false };
					})
					.finally(() => {
						this.accountLoading = false;
						if (this.cancelTokenSource === source) {
							this.cancelTokenSource = null;
						}
					});
			},
			immediate: true
		},
	},
	mounted() {
			this._setupHeightObserver();
			// 监听快捷回复选择事件（scroll 由模板 @scroll 绑定，无需 addEventListener）
			this.$eventBus.$on('quick-reply-selected', this.handleQuickReplySelected);
	},
	// 在 beforeDestroy 中移除事件监听
	beforeDestroy() {
			this.cancelTokenSource?.cancel();
			this._teardownHeightObserver();
			this.$eventBus.$off('quick-reply-selected', this.handleQuickReplySelected);
	}
}
</script>

<style lang="scss" scoped>
.chat-box {
	position: relative;
	width: 100%;
	background: #fff;

	.el-header {
		display: flex;
		justify-content: space-between;
		padding: 0 12px;
		line-height: 50px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);


		.header-left {
			display: flex;
			align-items: center;
			overflow: hidden;
			min-width: 0;

			> span {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.header-type-tag {
				margin-left: 8px;
				flex-shrink: 0;
			}
		}


			.header-right {
				display: flex;
				align-items: center;
				flex-shrink: 0;
			}
		.btn-side {
			margin-left: 12px;
			line-height: 50px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);

			&:hover {
				color: var(--im-color-primary);
			}
		}
	}

	.content-box {
		position: relative;

		.im-chat-main {
			padding: 0;
			overflow-y: auto;
			background-color: #f4f5f6;

			.im-chat-box {
				>ul {
					padding: 0 20px;

					li {
						list-style-type: none;
					}
				}
				
				// 时间提示样式
				.message-time-tip {
					text-align: center;
					margin: 15px auto;
					font-size: 12px;
					color: #999;
					padding: 4px 12px;
					background: rgba(255, 255, 255, 0.6);
					border-radius: 12px;
					display: table;
				}
			}
		}

		.scroll-to-bottom {
			text-align: right;
			position: absolute;
			right: 20px;
			bottom: 230px;
			color: var(--im-color-primary);
			font-size: var(--im-font-size);
			font-weight: 600;
			background: #eee;
			padding: 5px 15px;
			border-radius: 15px;
			cursor: pointer;
			z-index: 99;
			box-shadow: var(--im-box-shadow-light);
		}

		.im-chat-footer {
			display: flex;
			flex-direction: column;
			padding: 0;

			.chat-tool-bar {
				display: flex;
				position: relative;
				width: 100%;
				height: 36px;
				text-align: left;
				box-sizing: border-box;
				border-top: var(--im-border);
				padding: 4px 2px 2px 8px;

				>div {
					font-size: 22px;
					cursor: pointer;
					line-height: 30px;
					width: 30px;
					height: 30px;
					text-align: center;
					border-radius: 2px;
					margin-right: 8px;
					color: #999;
					transition: 0.3s;

					&.chat-tool-active {
						font-weight: 600;
						color: var(--im-color-primary);
						background-color: #ddd;
					}
				}

				>div:hover {
					color: #333;
				}
			}

			.send-content-area {
				position: relative;
				display: flex;
				flex-direction: column;
				height: 100%;
				background-color: white !important;

				.send-btn-area {
					padding: 10px;
					position: absolute;
					bottom: 4px;
					right: 6px;
				}
			}
		}
	}

	.side-box {
		border-left: var(--im-border);
	}

	// 发送视频确认弹窗
	.video-confirm-player {
		width: 100%;
		max-height: 260px;
		border-radius: 6px;
		background: #000;
		outline: none;
	}

	.video-confirm-info {
		margin-top: 12px;

		.video-confirm-name {
			font-size: 14px;
			color: #303133;
			word-break: break-all;
			line-height: 1.4;
		}

		.video-confirm-meta {
			margin-top: 6px;
			font-size: 12px;
			color: #909399;

			span + span {
				margin-left: 12px;
			}
		}

		.video-confirm-hint {
			margin-top: 8px;
			font-size: 12px;
			color: #e6a23c;
		}
	}
}
</style>

<style lang="scss">
/* 收藏小程序为快捷回复弹窗（el-dialog append-to-body，样式需全局，用类名前缀隔离） */
.chat-collect-dialog {
	.collect-preview {
		margin-bottom: 12px;
		padding: 8px 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 13px;

		.collect-preview-label {
			color: #909399;
		}

		.collect-preview-title {
			color: #303133;
			font-weight: bold;
		}
	}
}

/* 转发弹窗（el-dialog append-to-body，样式需全局，用类名前缀隔离） */
.chat-forward-dialog {
	.forward-preview {
		margin-bottom: 12px;
		padding: 8px 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 13px;

		.forward-preview-label {
			color: #909399;
		}

		.forward-preview-title {
			color: #303133;
			font-weight: bold;
		}
	}

	.forward-search {
		margin-bottom: 10px;
	}

	.forward-target-list {
		max-height: 320px;
		overflow-y: auto;
		border: 1px solid #ebeef5;
		border-radius: 4px;

		.forward-empty {
			padding: 24px 0;
			text-align: center;
			font-size: 13px;
			color: #909399;
		}

		.forward-target-item {
			display: flex;
			align-items: center;
			padding: 8px 12px;
			cursor: pointer;
			transition: background-color 0.15s;

			&:hover {
				background: #f5f7fa;
			}

			&.is-active {
				background: #ecf5ff;
			}

			+ .forward-target-item {
				border-top: 1px solid #f0f2f5;
			}

			.forward-target-info {
				flex: 1;
				min-width: 0;
				margin-left: 10px;
				text-align: left;

				.forward-target-name {
					font-size: 14px;
					color: #303133;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.forward-target-meta {
					margin-top: 2px;
					font-size: 12px;
					color: #909399;
				}
			}
		}
	}
}
</style>